import { observer } from 'mobx-react-lite'
import { lazy, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { ContainerLK } from 'sections/LKSection/shared/components/ContainerLK/ContainerLK'
import { Margin, Padding } from 'components/ui'
import { Button, Flex, Skeleton, Title } from 'components/uiKit'
import { useAsyncEffect } from 'utils/hooks/useAsyncEffect'

import { EmployeeRolesForm } from '../../components/Forms/EmployeeRolesForm/EmployeeRolesForm'
import { EmployeeKeys } from '../../data'

const getKey = (key: string) => `${EmployeeKeys.addEmployeePage}.${key}`

export const EditEmployeePage = observer(() => {
  const { viewPvzUiStore, viewEmployeeUiStore: uiStore } = useStore()

  const { pvzId, userId } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [isEdit, setIsEdit] = useState(true)
  const [loading, setLoading] = useState(false)

  useAsyncEffect(async () => {
    setLoading(true)

    if (viewPvzUiStore.pvzList.length === 0) {
      await viewPvzUiStore.getPvzList()
    }

    if (pvzId) {
      await viewPvzUiStore.switchPvz(+pvzId)
    }

    if (userId) {
      uiStore.setSelectedUserId(+userId)

      if (uiStore.employeeList.length === 0) {
        await uiStore.getEmployeeList()
      }

      const employee = uiStore.employeeStore.getEntity(+userId)

      if (employee?.isDeleted) {
        setIsEdit(false)
      }
    }

    setLoading(false)
  }, [])

  return (
    <ContainerLK>
      <Padding py={32}>
        <Margin mb={32}>
          <Flex gap={16} align="center">
            <Button shape="circle" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} />

            <Skeleton loading={loading} paragraph={{ rows: 1 }}>
              <Title>{isEdit ? t(getKey('Настроить роль сотрудника')) : t(getKey('Восстановление сотрудника'))}</Title>
            </Skeleton>
          </Flex>
        </Margin>

        <EmployeeRolesForm formType={isEdit ? 'edit' : 'recover'} disabled={loading} />
      </Padding>
    </ContainerLK>
  )
})

export default EditEmployeePage

export const EditEmployeePageAsync = lazy(() => import('./EditEmployeePage'))
